export const projects = [
  {
    id: 1,
    name: "💻 CholtiBank (Financial Web Application)",
    title: "Financial Web Application",
    animation: "top",
    technologies: [
      "Next.js",
      "Redux Toolkit",
      "AOS",
      "axios",
      "clsx",
      "Flag Icons",
      "Framer Motion",
      "Friendly Challenge",
      "jwt-decode",
      "React Apexcharts",
      "React Countup",
      "React Fast Marquee",
      "React Hot Toast",
      "React Icons",
      "React Redux",
      "Swiper",
      "autoprefixer",
      "ESLint",
      "PostCSS",
      "Tailwind CSS",
      "TypeScript",
      "Prisma",
      "bcrypt",
      "cookie-parser",
      "cors",
      "dotenv",
      "Express",
      "HTTP Status",
      "jsonwebtoken",
      "Socket.IO",
      "Zod",
      "Lint Staged",
    ],
    description:
      "Cholti Bank, a cutting-edge digital banking platform, provides users with seamless financial control. Offering diverse services, users can deposit 💰, withdraw 💳, transfer funds 💸, and recharge mobile balances 💲.",
    liveSite: "https://cholti-bank-client.vercel.app/",
    clientSide: "https://github.com/git-sujon/CholtiBank-client",
    serverSide: "https://github.com/git-sujon/CholtiBank-server",
    images: [
      "https://i.ibb.co/wMf99gW/Cholti-Bank-7.png",
      "https://i.ibb.co/MgxfzmT/Cholti-Bank-2.png",
      "https://i.ibb.co/LDy6kzR/Cholti-Bank-3.png",
      "https://i.ibb.co/SXXwH4r/Cholti-Bank-8.png",
      "https://i.ibb.co/J7b6Ygj/Cholti-Bank-4.png",
      "https://i.ibb.co/SXLxQTC/Cholti-Bank-5.png",
    ],
  },
  {
    id: 2,
    name: "🏡 Indirect (Properties Buying & Selling Website)",
    title: "Properties Buying & Selling",
    animation: "top",
    technologies: [
      "React JS",
      "Node JS",
      "Express JS",
      "MongoDB",
      "Tailwind CSS",
      "JWT Token",
      "Axios",
      "React-query",
    ],
    description:
      "Indirect is a Fully functional MERN-Stack website, where the seller can sell their homes 🏠, apartment/flat 🏢, and other properties like office spaces 🏢. Also, they can showcase their property ads 📰, and buyers can complete the payment 💳 through the website.",
    liveSite: "https://indirect-fb2af.web.app/",
    clientSide: "https://github.com/git-sujon/indirect-client",
    serverSide: "https://github.com/git-sujon/Indirect-server",
    images: [
      "https://i.ibb.co/w0KTt9M/Indirect.png",
      "https://i.ibb.co/5GV83f9/Indirect2.png",
      "https://i.ibb.co/mzfN8zm/Indirect3.png",
    ],
  },
  {
    id: 3,
    name: "🧹 Cleaner Guy (Cleaning Services & Reviews website)",
    title: "Cleaning Services & Reviews",
    animation: "left",
    technologies: [
      "React JS",
      "Node JS",
      "Express JS",
      "MongoDB",
      "Tailwind CSS",
      "JWT Token",
    ],
    description:
      "Cleaner Guy is a cleaning services website, that includes customer reviews on various services. The website is built on MERN Stack and uses REST API 🛠️",
    liveSite: "http://cleaner-guy-f75f8.web.app",
    clientSide: "https://github.com/git-sujon/cleaner-guy-client",
    serverSide: "https://github.com/git-sujon/cleaner-guy-server",
    images: [
      "https://i.ibb.co/gmQ54WZ/Home-Cleaner-Guy.png",
      "https://i.ibb.co/D5yWfLk/cleanerguy2.png",
      "https://i.ibb.co/HGVJvtH/cleanerguy3.png",
    ],
  },

  {
    id: 4,
    name: "📝 Note Organizer App",
    title: " Note Organizer App",
    animation: "left",
    technologies: [
      "React",
      "React Redux",
      "Firebase",
      "React Hook Form",
      "React Hot Toast",
      "React Icons",
      "React Router DOM",
      "Express",
      "Mongoose",
      "JWT Token",
      "Zod",
      "Cors",
      "Dotenv",
      "HTTP Status",
    ],
    description:
      "Efficiently manage, categorize, and enhance your notes with this web app. Enjoy features like CRUD operations, categorization, advanced search, filtering, sorting, media integration, and pagination for a seamless note-taking experience. 💻📝🔥",
    liveSite: "https://simple-note-organizer.netlify.app",
    clientSide: "https://github.com/git-sujon/note-organizer-client",
    serverSide: "https://github.com/git-sujon/note-organizer-server",
    images: [
      " https://i.ibb.co/n120WHq/Note-Organizer.png",
      "https://i.ibb.co/b7mxLCK/Note-Organizer-4.png",
      "https://i.ibb.co/pPM8hz4/Note-Organizer-3.png",
      "https://i.ibb.co/vzD3rvy/Note-Organizer-2.png",
      "https://i.ibb.co/rc6GDJn/Note-Organizer-1.png",
    ],
  },

  {
    id: 5,
    name: "💻 PCWizardry (A PC Building website)",
    title: "A PC Building Website",
    animation: "right",
    technologies: [
      "Next.js",
      "Redux Toolkit",
      "Autoprefixer",
      "ESLint",
      "MongoDB",
      "NextAuth.js",
      "react-hot-toast",
      "React Icons",
      "React Redux",
      "Tailwind CSS",
      "daisyui",
    ],
    description:
      "PCWizardry is an online platform dedicated to PC building, offering customers assistance in selecting various computer components to create their ideal custom PC 🛠️",
    liveSite: "https://pcwizardry.vercel.app/",
    clientSide: "https://github.com/git-sujon/PCWizardry-A_PC_Builder_Website",
    serverSide:
      "https://github.com/git-sujon/PCWizardry-A_PC_Builder_Website/tree/main/src/pages/api",
    images: [
      "https://i.ibb.co/KK9qFYs/PCWizardry-1.png",
      "https://i.ibb.co/vLMxhYJ/pcwizardry-2.png",
      "https://i.ibb.co/JHsgWcP/pcwizardry-3.png",
      "https://i.ibb.co/PTbjkTB/pcwizardry-4.png",
    ],
  },
  {
    id: 6,
    name: "🎓 Erudite (An Online Course Provider website)",
    title: "Online Course Provider",
    animation: "right",
    technologies: [
      "React JS",
      "Node JS",
      "Express JS",
      "MongoDB",
      "Tailwind CSS",
    ],
    description:
      "Erudite means knowledge or learning. This website provides technology-based courses 🖥️ to students and professionals, with premium access 🔒.",
    liveSite: "https://erudite-courses-site.web.app/",
    clientSide: "https://github.com/git-sujon/Erudite-client",
    serverSide: "https://github.com/git-sujon/Erudite-server",
    images: [
      "https://i.ibb.co/VTnMfv9/Erudite.png",
      "https://i.ibb.co/BK1Nddd/Erudite-2.png",
      "https://i.ibb.co/6gbYdNs/Erudite-3.png",
    ],
  },
];
